const fullDate = (epochDate) => {
	const date = new Date(
		typeof epochDate === "string" ? parseInt(epochDate, 10) : epochDate
	);

	return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

export default fullDate;
